import { numberToLocaleString } from './numberUtil';
import { formatDateSimple } from './dateUtil';

/**
 * Returns a string from an answer.
 *
 * @param {*} question
 * @param {{ id: string; value: any }} answer
 */
export function answerToString(question, answer) {
  switch (question.type) {
    case 'BOOL':
      return answer ? 'Yes' : 'No';
    case 'TEXT':
      return answer ? answer.toString() : '';
    case 'NUMERIC':
      {
        var places = question.format && question.format.places || 0;
        return numberToLocaleString(answer, places);
      }
    case 'DATE_TIME':
      return formatDate(question, answer);
    case 'DOCUMENTS':
      if (!answer || !Array.isArray(answer)) {
        return '';
      }
      return (question.options || []).map(function (o) {
        var selected = answer.find(function (a) {
          return a.id === o.id;
        });
        return selected ? o.text : null;
      }).filter(Boolean).join(', ');
    case 'SELECT':
      if (!answer) {
        return question.multi ? [] : '';
      }
      return question.multi ? (question.options || []).map(function (o) {
        var helper = Array.isArray(answer) ? answer : [answer];
        var selected = helper.find(function (a) {
          return a === o.id;
        });
        return selected ? o.text : null;
      }).filter(Boolean).join(', ') : getOptionLabel(question, answer);
  }
  return '';
}

/**
 * Gets the option label for a select question.
 *
 * @param {*} question
 * @param {*} value
 */
function getOptionLabel(question, value) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : value;
  var options = question.options || [];
  var found = options.find(function (o) {
    return o.id === value;
  });
  if (!found) {
    return defaultValue;
  }
  return found.text;
}

/**
 * Formats the date
 * @param {*} question
 * @param {Date | string} answer
 */
function formatDate(question, answer) {
  if (!answer) {
    return '';
  }
  return formatDateSimple(answer, {
    time: !!question.collect_time
  });
}
//# sourceMappingURL=questionUtil.js.map
